export default function handleNavigation() {
    handleStickyNav();

    let windowWidth;
    let $header_page_overlay = $('.js-header-overlay');

    $(window).on('resize load', function () {
        windowWidth = $(window).outerWidth();
    });

    $('body').on('click', '.js-toggle-nav-dropdown', function () {
        if (windowWidth < 1280) {
            let $parentNavItem = $(this).parent();
            toggleNavDropdown($parentNavItem);
        }
    }).on('click', '.js-nav-back', function () {
        if (windowWidth < 1280) {
            let $parentNavItem = $(this).parent().parent();
            toggleNavDropdown($parentNavItem);
        }
    }).on('mouseover', '.navigation li.has-dropdown, .sub-nav', function () {
        if (windowWidth >= 1024) {
            $header_page_overlay.removeClass('header-overlay--out-active');
            $header_page_overlay.addClass('header-overlay--active');
        }
    }).on('mouseout', '.navigation li.has-dropdown, .sub-nav', function () {
        if (windowWidth >= 1024) {
            $header_page_overlay.removeClass('header-overlay--active');
            $header_page_overlay.addClass('header-overlay--out-active');
        }
    }).on('focusin', '.navigation li.has-dropdown', function () {
        if (windowWidth >= 1024) {
            $header_page_overlay.removeClass('header-overlay--out-active');
            $header_page_overlay.addClass('header-overlay--active');
        }
    }).on('focusout', '.navigation li.has-dropdown', function () {
        if (windowWidth >= 1024) {
            $header_page_overlay.removeClass('header-overlay--active');
            $header_page_overlay.addClass('header-overlay--out-active');
        }
    }).on('click', '.js-toggle-mobile-menu', function () {
        $('body').toggleClass('nav-active');
        return false;
    }).on('click', '.js-toggle-account-login', function () {
        if (windowWidth < 1024) {
            $(this).parents('.account-login').find('.account-login__dropdown').stop().slideToggle();
        } else if (windowWidth >= 1024 && windowWidth < 1280) {
            $(this).parents('.account-login').toggleClass('account-login--active');
            $header_page_overlay.toggleClass('active', $(this).parents('.account-login').hasClass('account-login--active'));
            $('.nav__item--dropdown').removeClass('nav__item--active');
            $('.nav-dropdown').removeClass('nav-dropdown--active');
        }
        return false;
    });
}

function toggleNavDropdown($element) {
    if ($element.hasClass('dropdown-active')) {
        $element.removeClass('dropdown-active');
    } else {
        $element.addClass('dropdown-active');
    }

    if ($('.dropdown-active').length > 0) {
        $('body').addClass('sub-nav-active');
    } else {
        $('body').removeClass('sub-nav-active');
    }
}

function handleStickyNav() {
    let $window = $(window);

    let windowWidth = $window.outerWidth();

    $(window).on("scroll", function () {
        updateStickyNav();
    }).on("resize", function () {
        let currentWidth = $window.outerWidth();

        if (windowWidth !== currentWidth) {
            updateStickyNav();
        }

        windowWidth = currentWidth;
    });

    $(window).trigger("scroll");
}

function updateStickyNav() {
    let scrollTop = $(window).scrollTop();

    if (scrollTop === 0) {
        $('body').removeClass('sticky-header');
        return;
    } else {
        $('body').addClass('sticky-header');
    }
}
